<template>
  <main class="jogos-detalhes-container">
    <div class="titulo-jogos">
      <h1>Nossos Projetos</h1>
    </div>

    <section
      v-for="project in projects"
      :key="project.name"
      class="jogo-detalhe"
    >
      <h2>{{ project.name }}</h2>

      <section class="jogo-topo">
        <iframe
          :src="`${project.trailer}`"
          :title="`Trailer ${project.name}`"
          loading="lazy"
          allow="autoplay; encrypted-media"
          allowfullscreen
        ></iframe>

        <div class="jogo-info">
          <p><strong>Gênero:</strong> {{ project.genre }}</p>
          <p><strong>Lançamento:</strong> {{ project.releaseDate }}</p>
          <p><strong>Descrição:</strong></p>
          <p>{{ project.description }}</p>
        </div>
      </section>

      
        <GaleriaLoop
            v-if="project.screenshots?.length"
            :imagens="project.screenshots"
        />

      <RouterLink
        :to="`/jogos/${project.name}`"
        class="saiba-mais">
      </RouterLink>

      <section class="playstore-area">
        <p class="playstore-texto">DISPONÍVEL NA PLAY STORE</p>
        <a
          :href="project.playstoreLink"
          target="_blank"
          rel="noopener noreferrer"
          class="playstore-botao"
        >
          <img :src="playstoreIcon" />
        </a>
      </section>
    </section>
  </main>
</template>

<script setup>
import { projects } from "@/data/projects"
import playstoreIcon from "@/assets/images/social-icons/playstore.png"
import { RouterLink } from "vue-router"
import GaleriaLoop from "@/components/GaleriaLoop.vue";
</script>

<style>
.jogos-detalhes-container {
    width: 1200px;
    margin: 0px auto 0 auto;
    display: flex;
    justify-content: space-evenly;
    gap: 20px;
    flex-wrap: wrap;
}

.titulo-jogos {
    width: 100%;
    text-align: center;
}

.titulo-jogos h1 {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
    margin: 0 auto;
    font-size: 22px;
    letter-spacing: 1px;
}

.titulo-jogos h1::before,
.titulo-jogos h1::after {
    content: "";
    flex: 1;
    height: 2px;
    background: linear-gradient(to right, transparent, #8B8F9C, transparent);
    box-shadow:
        0 1px 4px rgba(0, 0, 0, 0.6),
        0 0 8px rgba(139, 143, 156, 0.3);
}

.titulo-jogos h1::before {
    transform: scaleX(-1);
}

.jogo-detalhe {
    width: 540px;
    display: flex;
    flex-direction: column;
    background:
        linear-gradient(145deg, rgba(255, 255, 255, 0.04), rgba(0, 0, 0, 0.25)),
        var(--fundo-card);
    border: 2px solid var(--borda-card);
    border-radius: 14px;
    box-shadow:
        0 10px 24px var(--sombra-escura),
        inset 0 1px 0 rgba(255, 255, 255, 0.05);
}

.jogo-detalhe h2 {
    padding: 10px;
    font-size: 22px;
    letter-spacing: 1px;
    text-align: center;
    color: var(--texto-titulo);
    background-color: var(--fundo-card);
    border-bottom: 2px solid var(--borda-card);
    border-radius: 10px 10px 0 0;
}

.jogo-topo {
    display: flex;
    justify-content: center;
    gap: 10px;
    margin: auto;
    padding: 4px;
    flex-wrap: wrap;
}

.jogo-topo iframe {
    width: 245px;
    aspect-ratio: 16 / 9;
    border-radius: 10px;
    border: none;
}

.jogo-info {
    max-width: 270px;
}

.jogo-info strong {
    font-size: 15px;
}

.jogo-info p {
    font-size: 14px;
    margin-bottom: 4px;
}

.playstore-area {
    margin: 20px auto 0;
    text-align: center;
}

.playstore-texto {
    font-size: 12px;
    font-weight: bold;
    letter-spacing: 1px;
    color: var(--texto-suave);
}

.playstore-botao {
    display: flex;
    align-items: center;
    justify-content: center;
}

.playstore-botao img {
    height: 40px;
    margin: 10px;
    transition: transform 0.25s ease;
}

.playstore-botao:hover {
    transform: scale(1.08);
}
</style>
